import { ShieldCheckFilledIcon } from '@sharedCR/coreDesignSystem/icons';

import { NAVIGATION_ITEM_TYPE } from 'constants/navigation';
import { PAGE_CODES } from 'constants/pageCodes';

import { UnderwritingPaths } from './routesConfig/underwriting';

export const underwritingNavItem = {
  id: 'underwriting-category',
  title: 'Underwriting',
  type: NAVIGATION_ITEM_TYPE.COLLAPSE,
  icon: ShieldCheckFilledIcon,
  children: [
    {
      id: 'condition-set',
      title: 'Condition Sets',
      type: NAVIGATION_ITEM_TYPE.ITEM,
      url: UnderwritingPaths.conditionSet.path,
      pageCode: PAGE_CODES.UNDERWRITING_CONDITIONS,
    },
    {
      id: 'conditions',
      title: 'Conditions',
      type: NAVIGATION_ITEM_TYPE.ITEM,
      url: UnderwritingPaths.conditions.path,
      pageCode: PAGE_CODES.UNDERWRITING_CONDITIONS,
    },
    {
      id: 'condition-categories',
      title: 'Condition Categories',
      type: NAVIGATION_ITEM_TYPE.ITEM,
      url: UnderwritingPaths.conditionCategories.path,
      pageCode: PAGE_CODES.UNDERWRITING_CONDITION_CATEGORIES,
    },
    {
      id: 'prior-to-types',
      title: 'Prior To Types',
      type: NAVIGATION_ITEM_TYPE.ITEM,
      url: UnderwritingPaths.priorToTypes.path,
      pageCode: PAGE_CODES.UNDERWRITING_CONDITION_CATEGORIES,
    },
    {
      id: 'search-synonyms',
      title: 'Search Synonyms',
      type: NAVIGATION_ITEM_TYPE.ITEM,
      url: UnderwritingPaths.searchSynonyms.path,
      pageCode: PAGE_CODES.UNDERWRITING_CONDITIONS,
    },
    {
      id: 'rules',
      title: 'Underwriting Rules',
      type: NAVIGATION_ITEM_TYPE.ITEM,
      url: UnderwritingPaths.rules.path,
      pageCode: PAGE_CODES.UNDERWRITING_RULES,
    },
    {
      id: 'settings',
      title: 'Document Expiration',
      type: NAVIGATION_ITEM_TYPE.ITEM,
      url: UnderwritingPaths.settings.path,
      pageCode: PAGE_CODES.UNDERWRITING_SETTINGS,
    },
    {
      id: 'document-expiration-settings',
      title: 'Document Expiration Settings',
      type: NAVIGATION_ITEM_TYPE.ITEM,
      url: UnderwritingPaths.documentExpirationSettings.path,
      pageCode: PAGE_CODES.UNDERWRITING_DOCUMENT_EXPIRATION_SETTINGS,
    },
  ],
};
